<template>
  <div>
    <GrmBtn color="gray" @click="onBack">{{ $t("testBank.goBack") }}</GrmBtn>
    <div class="mt-4 -mx-3 py-8 px-10 bg-gray-100 lg:mt-10 lg:-mx-10 lg:px10">
      <div class="flex flex-col gap-y-6">
        <div class="flex gap-x-4">
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("setting.name.title") }}</div>
            <p class="rounded-lg py-3 px-4 bg-white text-sm">{{ testbankExamHistory.examTitle }}</p>
          </div>
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.style") }}</div>
            <div>
                <GrmBtn :color="testbankExamHistory.examType === 'QUIZ' ? 'purple' : 'green'"
                        hoverColor="none"
                        disabled
                >{{ testbankExamHistory.examType === 'QUIZ' ? $t('testBank.write') : $t('testBank.survey') }}</GrmBtn>
            </div>
          </div>
        </div>
        <div class="flex gap-x-4">
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("common.name") }}</div>
            <p class="text-sm break-words">{{ testbankExamHistoryUser.username }}</p>
          </div>
          <div class="min-w-0 flex-1 flex flex-col gap-y-2"
               v-if="testbankExamHistory.examType === 'QUIZ'"
          >
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.score") }}</div>
            <p class="text-sm break-words">{{ testbankExamHistoryUser.examScore }}{{ $t('exam.question.point') }}</p>
          </div>
        </div>
        <div class="flex gap-x-4">
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.limit") }}</div>
            <p class="text-sm break-words">{{ examDuration(testbankExamHistory) }}</p>
          </div>
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.period") }}</div>
            <p class="text-sm break-words">{{ testbankExamHistory.beginDate }} ~ {{ testbankExamHistory.endDate }}</p>
          </div>
        </div>
        <div class="border-t border-gray-300 pt-6 flex flex-col items-center"
             v-if="testbankExamHistory.examType === 'QUIZ'"
        >
          <p class="font-bold">{{ $t("testBank.answerTable") }}</p>
          <TestbankResultCorrectTable class="mt-4" :questionList="userQuestionList" />
        </div>
      </div>
    </div>
    <component v-for="(userQuestion, i) in userQuestionList"
               :is="userQuestion.questionType === 'CHOICE' ? 'TestbankHistoryQuestionChoice' : 'TestbankHistoryQuestionSubjective'"
               :key="userQuestion.questionId"
               :index="i"
               :question="userQuestion"
               :examTypeQuiz="testbankExamHistory.examType === 'QUIZ'"
    />
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {cloneDeep} from "lodash";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import TestbankResultCorrectTable from "@/components/Room/Testbank/Result/TestbankResultCorrectTable.vue";
import TestbankHistoryQuestionChoice from "@/components/Room/Testbank/History/TestbankHistoryQuestionChoice.vue";
import TestbankHistoryQuestionSubjective from "@/components/Room/Testbank/History/TestbankHistoryQuestionSubjective.vue";

export default {
  name: 'TestbankHistoryUser',
  components: {
    GrmBtn,
    TestbankResultCorrectTable,
    TestbankHistoryQuestionChoice,
    TestbankHistoryQuestionSubjective,
  },
  computed: {
    ...mapState('testbank', [
      'testbankExamHistory',
      'testbankExamHistoryList',
      'testbankExamHistoryUser',
    ]),
    ...mapMutations('testbank', [
      'SET_TESTBANK_EXAM_HISTORY',
    ]),

    userQuestionList() {
      const _testbankExamHistoryList = cloneDeep(this.testbankExamHistoryList)
      const userQuestionList = _testbankExamHistoryList.content
          .find(exam => exam.roomExamId === this.testbankExamHistory.roomExamId)
          .bankExam.questionList;

      for (const question of userQuestionList) {
        const userQuestion = this.testbankExamHistoryUser.userQuestionList.find(userQuestion => userQuestion.questionId === question.questionId);
        if (!userQuestion) {
          continue;
        }

        const roomExamUser = this.testbankExamHistory.roomExamUserList.find(roomExamUser => roomExamUser.userId === this.testbankExamHistoryUser.userId);
        const roomExamUserQuestionList = roomExamUser.userQuestionList
        const roomExamUserQuestion = roomExamUserQuestionList.find(roomExamUserQuestion => roomExamUserQuestion.questionId === question.questionId);

        this.$set(question, 'userCorrectAnswerCnt', roomExamUserQuestion.userCorrectAnswerCnt);
        ['userAnswerList', 'correct'].forEach(key => {
          this.$set(question, key, userQuestion[key]);
        });
      }

      return userQuestionList;
    },
    examDuration() {
      return exam => {
        const duration = exam.examDuration;
        const hour = Math.floor(duration / 3600);
        const minute = Math.floor((duration % 3600) / 60);
        const second = duration % 60;
        return `${hour ? hour + this.$t('common.hour') + ' ' : ''}${minute ? minute + this.$t('common.minute') + ' ' : ''}${second ? second + this.$t('common.second') : ''}`;
      }
    }
  },
  methods: {
    ...mapMutations('testbank', [
      'SET_VIEW',
    ]),

    onBack() {
      this.SET_VIEW('history__exam');
    }
  }
}
</script>